import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TemplatesSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TemplatesSVG;
